import React, { Component } from "react";
import '../../styles/components/Testimonials.css';
import Dora_img from '../assets/Dora_img.png';
import Susannah_img from '../assets/Susannah_img.png';
import Shrinidhi_img from '../assets/Shrinidhi_img.png';
import Laura_img from '../assets/Laura_img.png';
import Divya_img from '../assets/Divya_img.png';
import pat_img from '../assets/Pat_img.png';
import Ravi_img from '../assets/Ravi_img.jpeg';
import no_img from '../assets/No_img.png';

export default class Testimonials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeAccordion: null
    };
  }

  toggleAccordion = (index) => {
    this.setState(prevState => ({
      activeAccordion: prevState.activeAccordion === index ? null : index
    }));
  };

  render() {
    const testimonials = [
      {
        name: "Ravi Haldahalli",
        title: "SVP of Sports Technology, Bally’s Interactive",
        image: Ravi_img,
        content: [
          "I had the pleasure of working closely with Chidrupa during her time as a Product Designer at Bally’s Interactive, where she contributed across a range of our most strategically important product initiatives.",
          "What stood out most about Chidrupa was her initiative and collaborative instinct. She proactively organized a Design Knowledge Transfer session to ensure continuity across the team — exactly the kind of ownership you want from a designer embedded in a fast-moving product org. She was equally comfortable in detailed design reviews, cross-functional discussions, and higher-level product strategy conversations.",
          "Chidrupa brought both craft and curiosity to her work. She engaged enthusiastically with the broader team, asked sharp questions, and consistently sought to understand the business context behind design decisions — not just the pixels. She’ll be an asset to any product team that values designers who can operate across the full spectrum from execution to product thinking.",
          "I recommend Chidrupa without hesitation and look forward to seeing what she builds next."
        ]
      },
      {
        name: "Robert Slattery",
        title: "Director of UX, Schrodinger",
        image: no_img,
        content: [
          "Chidrupa is a fantastic UX designer, and I strongly recommend her as a great addition to any UX team. I had the opportunity to work with Chidrupa for 1.5 years on a variety of high-level projects across the Schrodinger platform. She contributed greatly in all facets of these projects, collaborating with a diverse set of team members, such as scientists, developers, product managers, account managers, designers, QA, and support staff. She is a great teammate to work with, and possesses strong communication and design collaboration skills.",
          "Chidrupa always takes initiative and is excited about exploring creative ideas and crafting great UX solutions. Chidrupa is a strong user researcher, asking relevant questions and follow-ups, discerning insights and communicating her findings with colleagues. She crafts very strong user stories, wireframes, interactive prototypes, and beautiful high-fidelity designs. She works very efficiently, learns quickly, and has a great natural eye for design. She is an expert in Figma, and modern tools (Jira, Confluence, Google Slides), that has helped raise the team's quality of work.",
          "Chidrupa took on a number of projects for the medicinal chemistry LiveDesign web application, each in various stages of completeness, and was able to get all of them through the product process and ready for development. These included fundamental features such as formula building, data coloring, searching, and dialog re-designs. She worked with the development team through implementation, as well as the Quality Assurance team to finalize the projects for production.",
          "Chidrupa also excelled at designing new scientific UI's for the Maestro computational chemistry desktop application such as biological entity import and management, ligand database exploration, and other tools for drug discovery workflows. She further guided the formalization of our design system in Figma, to make collaboration across teams more efficient.",
          "Chidrupa is always eager to take on new challenges, no matter the difficulty, and consistently delivers great solutions. I highly recommend Chidrupa and know she will continue to produce great work."
        ]
      },
      {
        name: "Pat Lorton",
        title: "CTO, COO, Schrodinger",
        image: pat_img,
        content: [
          "Chidrupa joined Schrödinger without a background in our industry, and soaked it up at an incredible pace and combined it with a great instinct and ability in designing interfaces. She was fantastic to work with, and was able to complete very high quality work on often short timeframes. She has her own talent in design, but also works well with all parties to make sure that her designs are well balanced and take all requirements into consideration.",
          "She's a fantastic and productive team member that any company would be very happy to have."
        ]
      },
      {
        name: "Laura Beck",
        title: "Staff UX Architect, Schrodinger",
        image: Laura_img,
        content: [
          "Chidrupa came to us as an intern, straight out of grad school, and we were so impressed by her that we offered her a permanent position after just a few weeks. She was able to absorb a huge amount of information about our very complex products in a short time - and make significant contributions to their UX. She was quick to pick up on the problems that needed to be solved, and creative in coming up with solutions. Often, when I would start to point out an issue, she would jump right in, having already noticed it herself. While she took feedback and direction quite well, she was also very comfortable working independently on projects - getting requirements from Product Managers, interviewing users, consulting with Developers and other interested parties, and iterating on her designs. Last but not least, she was a sunny, friendly presence in our office. We miss her already (as do the various project teams she worked with)!"
        ]
      },
      {
        name: "Divya Vuthaluru",
        title: "UX Designer II, Schrodinger",
        image: Divya_img,
        content: [
          "I worked with Chidrupa on the UX team where she joined as an intern and quickly transitioned into a full-time UX designer. She stood out to me for her thoughtful approach to UX. She always puts the user first, asks the right questions, and looks for ways to make the product easier and better to use. She's good at turning what she learns from interviews and site visits into clear, useful ideas to improve the product. She communicates clearly, gives well-thought-out feedback, and welcomes feedback to improve her work.",
          "Working with her was smooth, productive, and genuinely enjoyable. Curious and eager to learn, she likes to stay updated with the latest developments in the UX field and tries to continuously upskill herself.",
          "She is very proficient in Figma. She created Design System in Figma that bridges the needs of designers and developers with strong focus on usability, efficiency, and consistency.",
          "She's a friendly, fun teammate who brought great energy to the team — we already miss her!"
        ]
      },
      {
        name: "Aditi Dalvi",
        title: "UX Designer II, Schrodinger",
        image: no_img,
        content: [
          "I had the chance to work with Chidrupa on the same project, and she did an amazing job on the Design System. She worked closely with the developers to make sure everything was built well and looked great.",
          "Chidrupa picks up new things very quickly and always improves her designs based on feedback. Her UI designs are easy to use, thoughtful, and always focused on solving the right problems.",
          "She's a great team player, always ready to help and give useful suggestions, and she's been very supportive throughout our time working together. I'd happily recommend her to any team looking for a talented and dedicated designer."
        ]
      },
      {
        name: "Dora Lohas",
        title: "Founder, CEO of Ourdate",
        image: Dora_img,
        content: [
          "Chid is a problem solver, a doer, and willing to take on challenges. She was able to work alone or with our team really well. She is skillful in research, and wireframing, and is able to showcase different designs fast. It's rare to see a UX designer be able to put ideas to reality (the design) so effectively. I highly recommend working with Chid!"
        ]
      },
      {
        name: "Susannah Dhamdhere",
        title: "Founder, Lassi and Spice",
        image: Susannah_img,
        content: [
          "This past few months I've had the immense pleasure of working with Chidrupa Mamunooru, a grad student in UX Design at ASU. Chidrupa reached out to ask if she could work on a redesign of the Lassi & Spice website for a class project, and I was more than happy to oblige!",
          "Chidrupa is a talented web designer, and worked with skill and professionalism throughout the project. And, if you check out her portfolio here https://lnkd.in/g2Nfr3dj, the result is incredible! It's a major upgrade in the look and functionality of our website that I can't wait to implement."
        ]
      },
      {
        name: "Shrinidhi Patil",
        title: "Lead Software Engineer, Deloitte",
        image: Shrinidhi_img,
        content: [
          "I am delighted to write a LinkedIn recommendation for Chidrupa, who I had the pleasure of working with as a fresher UI developer. She is an exceptional talent who truly impressed me with their skills and work ethic.",
          "Throughout her time on our team, Chidrupa consistently demonstrated a remarkable aptitude for UI design and development. Her ability to grasp complex concepts and apply them to create intuitive and user-friendly interfaces was truly commendable.",
          "She was not just a quick learner but also had a keen eye for detail, ensuring that every project they worked on met the highest quality standards. I have no doubt that Chidrupa will continue to excel in their career as a UX developer and be a valuable asset to any team they join. I highly recommend her for any UX-related role and have no doubt that she will make a positive impact wherever she goes."
        ]
      }
    ];

    return (
      <div className='Testimonials'>
        <div className="testimonials-accordion">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className={`testimonial-accordion-item ${this.state.activeAccordion === index ? 'active' : ''}`}
            >
              <button 
                className="testimonial-accordion-header"
                onClick={() => this.toggleAccordion(index)}
              >
                <div className="testimonial-header-content">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name} 
                    className="testimonial-avatar"
                  />
                  <div className="testimonial-profile">
                    <h3>{testimonial.name}</h3>
                    <h4>{testimonial.title}</h4>
                  </div>
                </div>
                <div className="accordion-icon">
                  <svg 
                    width="24" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <polyline points="6,9 12,15 18,9"></polyline>
                  </svg>
                </div>
              </button>
              <div className="testimonial-accordion-content">
                <div className="testimonial-content">
                  {testimonial.content.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}